"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _draftJs = require("draft-js");
const Link = _ref => {
  let children = _ref.children,
    entityKey = _ref.entityKey;
  const _Entity$get$getData = _draftJs.Entity.get(entityKey).getData(),
    href = _Entity$get$getData.href,
    target = _Entity$get$getData.target;
  return /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    target: target
  }, children);
};
var _default = exports.default = Link;